import MKTypography from "components/MKTypography";

import logoCT from "assets/images/favicon.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Modelagem Matemática Inclusiva",
    image: logoCT,
    route: "/",
  },
  socials: [],
  menus: [
    {
      name: "Ajuda",
      items: [
        { name: "Contate-nos", href: "/FaleConosco " },
        { name: "", href: "" },
        { name: "", href: "" },
        { name: "", href: "" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      Direitos reservados. Copyright &copy; {date} M.M.I{" "}
      <MKTypography
        component="a"
        href=""
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        IFPR
      </MKTypography>
      .
    </MKTypography>
  ),
};
